import genericStore from "../generic_store";

export default {
    namespaced: genericStore.namespaced,
    state: {
        ...genericStore.state,
        endpoint: "faqs",
        object: "faq",
        header: [
            { text: "Pregunta", value: "question" },
            { text: "Respuesta", value: "answer" },
            { text: "Tipos", value: "types" },
            { text: "Acciones", value: "actions", sortable: false }
        ],
        types: ['GENERAL','DRIVER','OWNER']
    },
    mutations: {
        ...genericStore.mutations
    },
    actions: {
        ...genericStore.actions
    },
    getters: {
        ...genericStore.getters
    }
};
